/**
* description:
* File of container LoginSubscriberPasswordForm Component (Dumb)
*
* data : 2017-08-03
*/

import { mapActions } from 'vuex';

// CHILD COMPONENTS ////////////////////////////////////////////////////////////
import SmallLoadingSpinner from '@/components/Common/SmallLoadingSpinner';
import LoginErrorMessages from '@/components/Login/LoginErrorMessages';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'LoginSubscriberPasswordForm',

  components: {
    LoginErrorMessages, SmallLoadingSpinner,
  },

  props: ['subscriber', 'loginCredentialsIncorrect', 'loginLoadingActive'],

  data() {
    return {
      password: null,
    };
  },

  beforeMount() {
    this.resetPassword();
  },

  methods: {
    ...mapActions(['validatePassword', 'undoLoginState', 'confirmChangePassword']),
    returnToNumberInput() {
      this.undoLoginState('initial');
    },
    submitPassword() {
      const password = this.password;
      this.validatePassword({ password });
    },
    resetPassword() {
      this.password = null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Login/LoginSubscriberPasswordForm/component.js